// TODO: remove all bulk order related code since it will not be implemented anymore epic DCPR-7997

export const B2B_AVAILABLE_PRODUCTS = [] as string[];
